import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

const AnimatedHand: React.FC = () => {
  const [icon, setIcon] = useState("fa-hand-paper"); // initial icon

  useEffect(() => {
    let isMounted = true;

    function animateHand() {
      if (!isMounted) return;

      setIcon("fa-hand-paper");
      setTimeout(() => setIcon("fa-hand-peace"), 500);
      setTimeout(() => setIcon("fa-hand-spock"), 1000);
      setTimeout(() => setIcon("fa-hand-peace"), 1500);
    }

    // Run immediately
    animateHand();

    // Loop every 2s
    const interval = setInterval(animateHand, 2000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="text-5xl text-yellow-500 flex justify-center items-center mt-6">
      {/* <i className={`fa-solid ${icon} transition-all duration-200`}></i> */}
        <div className="animate-pulse  text-5xl">
            <i className={`fa-solid ${icon}`}></i>
        </div>
    </div>
  );
};

export default AnimatedHand;
